import { render, staticRenderFns } from "./storageAndDry.vue?vue&type=template&id=b532b85c&scoped=true&"
import script from "./storageAndDry.vue?vue&type=script&lang=js&"
export * from "./storageAndDry.vue?vue&type=script&lang=js&"
import style0 from "./storageAndDry.vue?vue&type=style&index=0&id=b532b85c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b532b85c",
  null
  
)

export default component.exports